import { render } from "./InitView.vue?vue&type=template&id=206992a0&scoped=true"
import script from "./InitView.vue?vue&type=script&lang=js"
export * from "./InitView.vue?vue&type=script&lang=js"

import "./InitView.vue?vue&type=style&index=0&id=206992a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206992a0"]])

export default __exports__